<template>

    <div class="d-flex flex-row my-5 justify-content-center w-100">

        <!-- Loading -->
        <loading/>

        <form @submit.prevent="sendData(routine)" class="form-module" method="post" action="" aria-describedby="Create Blog Category" enctype="multipart/form-data" autocomplete="on">

            <div class="mb-3 w-100 d-flex flex-row justify-content-center form_required">
                <small>Todos os inputs indicados com * são obrigatórios</small>
            </div>

            <div class="mb-4 d-flex flex-column justify-content-center align-items-center w-100">

                <div data-reference="name" class="d-flex flex-column order-1 mb-3" style="width: 45%;">
                    <label for="name" class="form-label">Nome*</label>
                    <input 
                        type="text" 
                        @focusin="inputValidationCase('name')"
                        @focusout="inputValidationCase('name')"  
                        v-model="name" 
                        class="form-control" 
                        id="name" 
                        placeholder="Nome da Categoria"
                        maxlength="130"
                    >
                </div>

                <div data-reference="description" class="d-flex flex-column order-2 mb-3" style="width: 45%;">
                    <label for="description" class="form-label">Descrição</label>
                    <textarea
                        class="form-control" 
                        @focusin="inputValidationCase('description')"
                        @focusout="inputValidationCase('description')"  
                        v-model="description"
                        placeholder="Descrição da Categoria" 
                        id="description"
                        maxlength="300"
                    >
                    </textarea>
                </div>
               
            </div>

            <div class="mb-4 d-flex flex-column justify-content-center align-items-center">

                <div class="btnimageactions d-flex flex-row justify-content-start order-1">

                    <button
                        @click="onlyShowModal('insertmedia')" 
                        class="btn btn-primary"
                        type="button"
                    >
                        Add Image
                    </button>

                    <button
                        @click="onlyShowModal('baseselectimage')" 
                        class="btn btn-secondary ms-3"
                        type="button"
                    >
                        Select Image
                    </button>

                </div>

            </div>

            <div class="my-3 float-end">
                <button type="submit" class="btn btn-primary" :disabled="disabled">Submit</button>
            </div>

        </form>

        <!-- Modal for Insert Media -->
        <modal
            title="Insert Media"
            classname="insertmedia"
        >

            <template #modalcontent>

                <!-- Insert Media Element -->
                <insert-media 
                    :csrftolken="csrftolken"
                    :mediainsert="mediainsert"
                    modalclassname="insertmedia"
                    responseclassname="responsebasemessage"
                    :removeresponsemessages="removeResponseMessages"
                    :checklocalstorage="checkLocalStorage"
                />

            </template>

        </modal>

        <!-- Modal for Select Image -->
        <modal
            title="Select Image"
            classname="baseselectimage"
        >

            <template #modalcontent>

                <!-- Media List -->
                <media-list
                    :allmediafiles="allmediafiles"
                    @choose-image="chooseImage($event)"
                />

            </template>

        </modal>

        <!-- Response Messages -->
        <div class="order-3 responsebasemessage" ref="responsebasemessage">

            <list-message/>

        </div>

    </div>

</template>
<script>
import fetchData from './../../fetchData.js';
import htmlElements from './../../htmlElements';
import inputValidation from './../../validationInputs.js';
import ListMessage from './../elements/ListMessageElement.vue';
import Loading from './../elements/LoadingElement.vue';
import Modal from './../elements/ModalElement.vue';
import InsertMedia from './../elements/MediaInsertElement.vue';
import MediaList from './../elements/MediaListElement.vue';

//Set Use Strict
"use strict";

export default{
    name: "BlogCategoryForm",
    props:{

        csrftolken:{
            type: String,
            required: true
        },
        routine:{
            type: String,
            required: true
        },
        moduleindex:{
            type: String,
            required: true
        },
        routineurl:{
            type: String,
            required: true
        },
        moduledata:{
            type: Array,
            required: true
        },
        customdata:{
            type: Array,
            required: false
        },
        mediainsert:{
            type: String,
            required: true
        },
        imagestoragepath:{
            type: String,
            required: true
        },

    },
    data: () => {

        return {

            name: '',
            description: '',
            disabled: true,
            inputNotIsValid: true,
            activeclass: 'd-flex',
            moduleData: [],
            allmediafiles: {},
            allmediafileslocalstorage: {},
            filedataform: {},

        }

    },
    created(){

        //Get All Media Data
        this.checkLocalStorage();

        //Set Customer Card Plan
        this.moduleData = this.moduledata;

    },
    mounted(){

        //Set Values for Update Routine
        this.setValuesForUpdate(this.moduleData);

    },
    methods:{

        chooseImageFiledata(element){

            //Get Filedata from select image
            let filedata = {
                name: 'category_image',
                imageid: element.target.getAttribute('data-fileid'),
                filealt: element.target.getAttribute('data-filealt'), 
                fileext: element.target.getAttribute('data-fileext'), 
                filenamenew: element.target.getAttribute('data-filenamenew'), 
                filenameold: element.target.getAttribute('data-filenameold')
            };

            //Reference Element for render image
            let elementReference = document.querySelector('.btnimageactions');

            //Check Element to search img tag
            if(!document.querySelector('.image-input')){

                //Set Image Element related 
                elementReference.after(this.renderImage(filedata, filedata.imageid, element));

            }else{

                //Remove reference before add a new image
                document.querySelector('.image-input').remove();

                //Set Image Element related 
                elementReference.after(this.renderImage(filedata, filedata.imageid, element));

            }

            //Set Relation with sectionid and image filedata
            Object.assign(this.filedataform, filedata);

        },
        chooseImage(element){

            //Disabled Button
            this.disabled = true;

            //Check InputId for Push
            if(this.filedataform.hasOwnProperty('imageid')){

                //Confirm New Image for Section
                let changeSelectImage = confirm('A imagem já foi selecionada para a categoria. Deseja a substituir ?');

                //Check Response
                if(changeSelectImage){

                    //Clean FileDataForm
                    this.filedataform = {};

                    //Set Fileformdata from select image
                    this.chooseImageFiledata(element);

                }

            }else{

                //Set Fileformdata from select image
                this.chooseImageFiledata(element);

            }

            //Enabled Button
            this.disabled = false;

            //Closed Model
            this.hideModal('baseselectimage');

        },
        checkLocalStorage(){

            //Set All Media
            this.allmediafileslocalstorage = localStorage.getItem('medialist');

            //Check Allmedia Files LocalStorage
            if(this.allmediafileslocalstorage){

                this.allmediafiles = JSON.parse(this.allmediafileslocalstorage);

            }

            return this.allmediafiles;

        },
        renderImage(filedata, imageid, element = null){

            let imageSrc = `${this.imagestoragepath}/${imageid}/thumb_${filedata.filenamenew}`;

            if(element !== null){

                imageSrc = element.target.getAttribute('data-thumb') === 'true' ? `${this.imagestoragepath}/${imageid}/thumb_${filedata.filenamenew}` : `${this.imagestoragepath}/original_default.jpg`;

            }

            //Image Element - Create Element
            let image = htmlElements.createElement('img',  {
                class: 'image-input my-4 order-2',
                data_filenameold: filedata.filenameold,
                data_filenamenew: filedata.filenamenew,
                data_filealt: filedata.filealt,
                alt: filedata.filealt,
                width: '190',
                height: '90',
                src: imageSrc
            });

            return image;

        },
        onlyShowModal(classname){

            //Show Modal
            $(`.${classname}`).modal("show");

            return;

        },
        hideModal(classname){

            //Hide Modal
            $(`.${classname}`).modal("hide");

        },
        inputValidationCase(inputid){

            //console.log(Object.entries(this.$data));

            //Check Inputs
            switch(inputid){

                //name
                case 'name':

                    this.disabled = inputValidation.validNameCases(4, this.name) ? false : true;

                break;

                //description
                case 'description':

                    this.disabled = inputValidation.validNameCases(4, this.description) ? false : true;

                break;

            }

            //Set Conditional for input is valid
            this.inputNotIsValid = this.disabled;

            //Show Error Message
            if(this.disabled){

                inputValidation.createErrorMessageElement(inputid, "Favor enviar dados válidos");

            }

        },
        removeResponseMessages(time = 5000){

            setTimeout(function(){

                //Remove active class
                document.querySelector('.responsebasemessage').classList.remove('d-flex');
                document.querySelector('.responsebasemessage').classList.remove('success');
                document.querySelector('.responsebasemessage').classList.remove('danger');

                //Remove children elements
                let ul = document.querySelector('.responsebasemessage').children;

                [...ul[0].children].forEach((valli) => {

                    //Remove Elements
                    valli.remove();

                });

            }, time);

        },
        setValuesForUpdate(moduleData){

            //Check Routine
            if(this.routine === 'POST'){

                return;

            }

            //Set Value
            this.name = moduleData[0].name;
            this.description = moduleData[0].description ? moduleData[0].description : "";
            this.filedataform = moduleData[0].image_data ? moduleData[0].image_data : {};

            //Render Image
            if(this.filedataform.hasOwnProperty('filenamenew')){

                //Reference Element for render image
                let elementReference = document.querySelector('.btnimageactions');

                //Set Image Id
                this.filedataform.imageid = moduleData[0].image_id;

                //Set Image Element related 
                elementReference.after(this.renderImage(this.filedataform, this.filedataform.imageid));

            }

            //Set Conditional
            this.inputNotIsValid = false;

            //Enabled Submit Button
            this.disabled = false;
           
        },
        sendData(method){

            //When the input is empty
            if(this.name === ''){

                //Callback Message
                alert('Necessário preencher os inputs indicados como obrigatórios');

                this.disabled = true;

                return this.disabled;

            }

            //Disabled Button
            this.disabled = true;

            //Active Loading
            document.querySelector('.loadingbase').classList.add('d-flex');

            let dataForm = {
                name: this.name.trim(),
                description: this.description.trim(),
                image: this.filedataform.hasOwnProperty('imageid') ? this.filedataform : null
            };

            //Check Routine
            if(this.routine === 'PUT'){

                dataForm.id = this.moduleData[0].id;

            }


            //Send Data
            let response = fetchData.structureTosendData(this.routineurl, dataForm, this.csrftolken, this.routine);

            //Check Promisse
            response.then((value) => {

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                //Add active Class
                this.$refs.responsebasemessage.classList.add(this.activeclass);
                this.$refs.responsebasemessage.classList.add(value.classname);

                //Element for append
                let li = `<li class="list-group item my-1">${value.message}</li>`;

                //Append Element
                $(li).appendTo(this.$refs.responsebasemessage.children);

                //Remove Message
                this.removeResponseMessages();

                //Check Response
                if(Object.is(value.classname, 'success')){

                    //Redirect for Module Index
                    window.location.replace(this.moduleindex);

                }

                //Enabled Button
                this.disabled = false;
                

            }).catch((error) => {

                //Enabled Button
                this.disabled = false;

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                throw new Error(error);

            });

        }

    },
    computed:{

        computedDisabled(){

            return this.disabled;

        },
        computedInputIsNotValid(){

            return this.inputNotIsValid;

        },
        computedAllMediaFiles(){

            return this.allmediafiles; 

        },
        computedFileFormList(){

            return this.filedataformlist;

        },
        computedFileDataFormUpdateList(){

            return this.filedataformupdatelist;

        },

    },
    watch:{

        computedDisabled(){},
        computedInputIsNotValid(){},
        computedAllMediaFiles(){},
        computedFileFormList(){},
        computedFileDataFormUpdateList(){}

    },
    components:{

        listMessage: ListMessage,
        loading: Loading,
        modal: Modal,
        insertMedia: InsertMedia,
        mediaList: MediaList,

    },
    beforeDestroy() {
        
        this.name = '';
        this.description = '';
        this.email = '';
        this.contact = '';
        this.position = '';
        this.user_rule = '';

    },

}

</script>